var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50977 9.34961V13.0913C2.50977 16.8329 4.00977 18.3329 7.75143 18.3329H12.2431C15.9848 18.3329 17.4848 16.8329 17.4848 13.0913V9.34961",
    stroke: "#3D3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 10.0003C11.5252 10.0003 12.6502 8.75866 12.5002 7.23366L11.9502 1.66699H8.05857L7.50024 7.23366C7.35024 8.75866 8.47524 10.0003 10.0002 10.0003Z",
    stroke: "#3D3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2591 10.0003C16.9425 10.0003 18.1758 8.63366 18.0091 6.95866L17.7758 4.66699C17.4758 2.50033 16.6425 1.66699 14.4591 1.66699H11.9175L12.5008 7.50866C12.6425 8.88366 13.8841 10.0003 15.2591 10.0003Z",
    stroke: "#3D3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69868 10.0003C6.07368 10.0003 7.31535 8.88366 7.44868 7.50866L7.63201 5.66699L8.03202 1.66699H5.49035C3.30702 1.66699 2.47368 2.50033 2.17368 4.66699L1.94868 6.95866C1.78201 8.63366 3.01535 10.0003 4.69868 10.0003Z",
    stroke: "#3D3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 14.167C8.60817 14.167 7.9165 14.8587 7.9165 16.2503V18.3337H12.0832V16.2503C12.0832 14.8587 11.3915 14.167 9.99984 14.167Z",
    stroke: "#3D3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.c21313f1eee101e1dd75668d6c61b03c.svg";
export { ForwardRef as ReactComponent };